import type { AccessoryProduct } from "@constants/formDefaults";

export const createGTMItems = (
  products: { sku: string; quantity: number }[],
  accessoryProducts: AccessoryProduct[],
) => {
  return products.map((item: { sku: string; quantity: number }) => {
    const productMeta = accessoryProducts?.find((p: AccessoryProduct) => p.SKU === item.sku);

    return {
      item_id: item.sku,
      item_name: productMeta?.Name ?? item.sku,
      quantity: item.quantity,
      price: productMeta?.PriceTier1 ?? 0,
      item_category: productMeta?.productCategories?.join(", ") ?? "",
    };
  });
};
